import { Dialog } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Formik } from 'formik';
import { useMeContext } from '~/modules/me/useMeContext';
import { RepliconDialog } from '~/modules/common/components';
import { useFormState, useOnSubmit } from './hooks';
import { ChangeResourceDialogBody } from './ChangeResourceDialogBody';

const dialogTitleId = 'ChangeResourceDialogTitle';

export const ChangeResourceDialog = ({
  canEditTask,
  existingResourceUser,
  onChangeResourceSuccess,
  onClose,
  open,
  projectId
}) => {
  const { initialValues } = useFormState();

  const { onChangeResourceUserSubmit } = useOnSubmit({
    existingResourceUserId: existingResourceUser.user.id,
    onClose,
    onChangeResourceSuccess,
    projectId
  });

  const {
    featureFlags: { isPsaRmp2025Q4WcagEnabled }
  } = useMeContext();

  const DialogComponent = isPsaRmp2025Q4WcagEnabled ? RepliconDialog : Dialog;

  return (
    <DialogComponent
      aria-labelledby={dialogTitleId}
      fullWidth
      open={open}
      onClose={onClose}
      trapFocusWithDatePicker={isPsaRmp2025Q4WcagEnabled}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={onChangeResourceUserSubmit}
      >
        <ChangeResourceDialogBody
          canEditTask={canEditTask}
          dialogTitleId={dialogTitleId}
          existingResourceUser={existingResourceUser}
          projectId={projectId}
          onClose={onClose}
        />
      </Formik>
    </DialogComponent>
  );
};

ChangeResourceDialog.propTypes = {
  canEditTask: PropTypes.bool.isRequired,
  existingResourceUser: PropTypes.object.isRequired,
  onChangeResourceSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  projectId: PropTypes.string.isRequired
};

export default ChangeResourceDialog;
